<div class="main-controls">
    <button
        class="btn-control click-outside-close-prevent btn-edit-action"
        [tooltip]="selectActionTooltip"
        (click)="selectAction()"
    >
        <span class="sp-icon icon-pencil"> </span>
    </button>
    <div
        class="btn-group"
        dropdown
        (onShown)="onOpenDropdown($event)"
        (onHidden)="onCloseDropdown()"
        container="body"
        #dropdownButton
    >
        <button class="btn-control dropdown-toggle" id="button-basic" dropdownToggle type="button">
            <span class="sp-icon icon-option-horizontal"> </span>
        </button>
        <ul
            *dropdownMenu
            id="dropdown-basic"
            class="dropdown-menu dropdown-menu-right"
            [class.dropdown-widget-custom-right]="widgetName"
            [class.dropdown-custom-right]="!widgetName"
            role="menu"
            aria-labelledby="button-basic"
        >
            @if (!disableCopyEvent) {
                <li role="menuitem">
                    <a class="dropdown-item" (click)="copyAction()">
                        <span class="sp-icon icon-copy"> </span>
                        {{ "duplicate" | translate }}
                    </a>
                </li>
            }
            @if (!disableCopyEvent) {
                <li class="divider dropdown-divider"></li>
            }
            <li role="menuitem" [tooltip]="disableRemoveEvent ? disableRemoveEventTooltip : ''" placement="bottom">
                <a class="dropdown-item" [class.disabled]="disableRemoveEvent" (click)="deleteAction()">
                    <span class="sp-icon icon-bin color-danger"> </span>
                    {{ "delete" | translate }}
                </a>
            </li>
        </ul>
    </div>
</div>
